import React,{useState} from 'react'
import { InputGroup, Button } from '../../UI'
import { handleError } from '../../lib'

const ConfirmEmailForm = ({ handleInput, formData, loading, resentMail }) => {

 const [clicks , setClicks] = useState(0);

 const statemanager =()=>{
   
   if(clicks<1){
    resentMail()
    setClicks(clicks + 1) 
   }  else {
    handleError("you can not click the button more than once")
   }
  }

  return (
     <>
      <InputGroup
        label="Token"
        name="token"
        type="token"
        required={true}
        placeholder={'Enter your Token'}
        value={formData.token}
        onChange={handleInput}
        error={false}
      />
        <Button
        full
        type="submit"
        className="auth--btn"
        loading={loading}
 spinnerWithTxt={true}
              >
        Confirm
      </Button>
      <footer>
        <p>
          No email has been sent? <span style={{color:"skyblue" , cursor:"pointer"}} onClick={statemanager }>Click here</span>
        </p>
      </footer>
    </>
  )
}

export default ConfirmEmailForm
